import { dateRangePresetIds } from '@branch-messenger/willow-ui'
import { fallback, zodValidator } from '@tanstack/zod-adapter'
import { z } from 'zod'

const schema = z.object({
  toDate: z.coerce.string().optional(),
  fromDate: z.coerce.string().optional(),
  datePreset: fallback(
    z.union([
      z.nativeEnum(dateRangePresetIds),
      z.string().and(z.object({})),
      z.undefined(),
    ]),
    undefined
  ).optional(),
})

export const payoutsSearchSchema = zodValidator(schema)
export type PayoutsSearchSchema = z.infer<typeof schema>
